import React, { Component } from 'react'
import CommonHeader from '../../navbars/CommonHeader';

// Analysis page header: the shared CommonHeader, in a colour of its own
// (page styles from .result-analysis-nav).
class TopNavbar extends Component {
    render() {
        return (
            <CommonHeader className="result-analysis-nav" color="auto" tone="light" container={false} onToggleSidebar={this.props.onClick} title={this.props.headerBottom && this.props.headerBottom.title} />
        )
    }
}

export default TopNavbar;
